<script>
  import DashboardTitle from "../../../../components/dashboard/DashboardTitle.svelte";
  import { onMount } from "svelte";
  import Picture from "../../../../components/Picture.svelte";
  export let boxTitle;
  export let project;

  let users = [];

  let prepareUsers = () => {
    /*users = project.people;
    users.sort((a) => (a.role === "Project Manager" ? -1 : 1));*/
    users = [];
    project.phases.forEach((phase) => {
      phase.people.forEach((p) => {
        const pos = users.findIndex((item) => {
          return item.peopleId === p.peopleId && item.role === p.role;
        });
        if (pos === -1) {
          users.push({
            peopleId: p.peopleId,
            peopleName: p.name,
            peoplePic: p.pic,
            role: p.role,
          });
        }
      });
    });
    users.sort((a) => (a.role === "Project Manager" ? -1 : 1));
    users = users;
  };

  onMount(async () => {
    prepareUsers();
  });

  $: if (project) {
    prepareUsers();
  }

  //console.log("PROYECTO: ", project);
</script>

<div class="dashboardContainer">
  <DashboardTitle title={boxTitle} numEvents={users.length} />
  <div class="dashboardBody customScrollbars">
    {#each users as p}
      <div class="userPic">
        <Picture
          image={p.peoplePic}
          name={p.peopleName + " - " + p.role}
          showHint={true}
        />
      </div>
    {/each}
  </div>
</div>

<style>
  div.dashboardContainer {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  div.dashboardBody {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    width: 100%;
    height: 85%;
    align-items: flex-start;
    justify-content: flex-start;
    overflow-y: scroll;
  }

  div.userPic {
    width: 40px;
    height: 40px;
    margin: 8px;
  }
</style>
